// Font-Awesome
import codeCurly from '!raw-loader!../../assets/icons/code-curly.svg';

export const iconsFontAwesome: Record<string, string> = {
  'code-curly': codeCurly,
};
